__turbopack_context__.v({
  "grid": "WalletUtxos-module__ZVxikG__grid",
  "loading": "WalletUtxos-module__ZVxikG__loading",
  "root": "WalletUtxos-module__ZVxikG__root",
});
